module.exports = __webpack_public_path__ + "img/markerIconWhiteMany.8ad98588.svg";